"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableSortOrder = exports.AvailableSortColumn = void 0;
var AvailableSortColumn;
(function (AvailableSortColumn) {
    AvailableSortColumn[AvailableSortColumn["QUALITY_SCORE"] = 0] = "QUALITY_SCORE";
    AvailableSortColumn[AvailableSortColumn["SALE_PRICE"] = 1] = "SALE_PRICE";
    AvailableSortColumn[AvailableSortColumn["SALE_PRICE_PER_SQFT"] = 2] = "SALE_PRICE_PER_SQFT";
    AvailableSortColumn[AvailableSortColumn["LEASE_PRICE"] = 3] = "LEASE_PRICE";
    AvailableSortColumn[AvailableSortColumn["LEASE_PRICE_PER_SQFT"] = 4] = "LEASE_PRICE_PER_SQFT";
    AvailableSortColumn[AvailableSortColumn["NET_SIZE"] = 5] = "NET_SIZE";
    AvailableSortColumn[AvailableSortColumn["GROSS_SIZE"] = 6] = "GROSS_SIZE";
    AvailableSortColumn[AvailableSortColumn["UPDATE"] = 7] = "UPDATE";
    AvailableSortColumn[AvailableSortColumn["BED"] = 8] = "BED";
    AvailableSortColumn[AvailableSortColumn["BATH"] = 9] = "BATH";
    AvailableSortColumn[AvailableSortColumn["NAME"] = 10] = "NAME";
})(AvailableSortColumn = exports.AvailableSortColumn || (exports.AvailableSortColumn = {}));
var AvailableSortOrder;
(function (AvailableSortOrder) {
    AvailableSortOrder[AvailableSortOrder["ASC"] = 0] = "ASC";
    AvailableSortOrder[AvailableSortOrder["DESC"] = 1] = "DESC";
})(AvailableSortOrder = exports.AvailableSortOrder || (exports.AvailableSortOrder = {}));
